import initJsonFormRenderer from "../scripts/json_form_renderer.js"
import inputJsonGroupWrapper from "../scripts/input_json_group_wrapper.js"

export default function initDynamicTable(wrapper) {
  if (wrapper.matches(".init")) return false

  const tableSelector = wrapper.dataset.tableTarget;
  const modalSelector = wrapper.dataset.modalTarget;
  const formContainerSelector = wrapper.dataset.formContainer;
  const visibleAttributes = JSON.parse(wrapper.dataset.visibleAttributes || "[]");
  const modelName = wrapper.dataset.modelName;
  const baseModelName = wrapper.dataset.baseModelName;

  const tableBody = wrapper.querySelector(`${tableSelector} tbody`);
  const modalEl = document.querySelector(modalSelector);
  const modal = new bootstrap.Modal(modalEl);
  const formContainer = document.querySelector(formContainerSelector);
  const addButton = wrapper.querySelector('[data-action="add"]');

  let currentEditRow = null;

  wrapper.classList.add("init")

  function renderRowFromHiddenInputs(row) {
    const data = extractRowObject(row);

    // sichtbare Zellen
    const visibleCells = buildVisibleCells(data);

    // Button-Zelle
    const actions = `
      <td>
        <button type="button" class="btn btn-sm btn-outline-secondary edit-row">Bearbeiten</button>
        <button type="button" class="btn btn-sm btn-danger remove-row">Löschen</button>
      </td>
    `;

    // hidden inputs müssen am Ende des TR bleiben
    const hiddenInputs = row.innerHTML;

    row.innerHTML = `
      ${visibleCells}
      ${actions}
      ${hiddenInputs}
    `;
  }

  if (tableBody) {
    tableBody.querySelectorAll("tr").forEach((row) => {
      if (!row.classList.contains("empty-placeholder")) {
        renderRowFromHiddenInputs(row);
      }
    });
  }


  // ---------------------------------------------------------------
  // Platzhalter wenn keine Zeilen existieren
  // ---------------------------------------------------------------
  function ensureEmptyPlaceholder() {
    if (!tableBody) return
    const realRows = tableBody.querySelectorAll(`tr:not(.empty-placeholder):not([data-destroy="1"])`);
    if (realRows.length === 0) {
      tableBody.innerHTML = `
        <tr class="empty-placeholder">
          <td colspan="${visibleAttributes.length + 1}" class="text-center text-muted py-4">
            Keine Datensätze vorhanden
          </td>
        </tr>
      `;
    } else {
      const placeholder = tableBody.querySelector(".empty-placeholder");
      if (placeholder) placeholder.remove();
    }
  }

  ensureEmptyPlaceholder();

  // ---------------------------------------------------------------
  // Hidden-Feld Objekt extrahieren
  // ---------------------------------------------------------------
  function extractRowObject(row) {
    const obj = {};
    row.querySelectorAll("input[type='hidden']").forEach((input) => {
      const match = input.name.match(/\[(\w+)\]$/);
      if (match) obj[match[1]] = input.value;
    });
    return obj;
  }

  // ---------------------------------------------------------------
  // Sichtbare Zellen (mit dynamischen Formatierfunktionen)
  // ---------------------------------------------------------------
  function buildVisibleCells(data) {
    return visibleAttributes
      .map((attr) => {
        let value = data[attr] || "";

        const fn = window[`${modelName}_${attr}`];
        if (typeof fn === "function") {
          try { value = fn(data); } catch(e) {}
        }

        return `<td class="${modelName}-${attr}">${value}</td>`;
      })
      .join("");
  }

  function updateVisibleCells(row, data) {
    const hiddenObj = extractRowObject(row);

    visibleAttributes.forEach((attr) => {
      const cell = row.querySelector(`.${modelName}-${attr}`);
      if (!cell) return;

      let value = data[attr] || "";

      const fn = window[`${modelName}_${attr}`];
      if (typeof fn === "function") {
        try { value = fn(hiddenObj); } catch(e) {}
      }

      cell.innerHTML = value;
    });
  }

  // ---------------------------------------------------------------
  // Hidden Inputs bauen (inkl. id + destroy)
  // ---------------------------------------------------------------
  function buildHiddenInputs(data, timestamp) {
    const fields = [];

    Object.entries(data).forEach(([key, value]) => {
      fields.push(
        `<input type="hidden" 
          name="${baseModelName}[${modelName}s_attributes][${timestamp}][${key}]" 
          value='${value}'>`
      );
    });

    return fields.join("\n");
  }

  // ---------------------------------------------------------------
  // ADD
  // ---------------------------------------------------------------
  addButton.addEventListener("click", () => {
    currentEditRow = null;
    const form = formContainer.querySelector(`#${modelName}-modal-form`);
    form.reset();
    form.querySelectorAll('select.country').forEach(x => {
      x.value = "DE"
    });
    form.querySelectorAll('[id$="-[salutation]"]').forEach(x => {
      x.value = "male"
    });
    document.querySelectorAll('.json-form-renderer').forEach(initJsonFormRenderer);
    form.querySelectorAll('.create-select, .multiple-select').forEach(select => {
      // window.choices[select.id].removeActiveItems();
    });
    if (addButton.dataset.formurl) {
      form.dataset.formurl = addButton.dataset.formurl
    } else {
      modal.show();
    }
  });

  // ---------------------------------------------------------------
  // EDIT
  // ---------------------------------------------------------------
  wrapper.addEventListener("click", (e) => {
    if (!e.target.matches(".edit-row")) return;

    const row = e.target.closest("tr");
    currentEditRow = row;

    const data = extractRowObject(row);
    const form = formContainer.querySelector(`#${modelName}-modal-form`);
    form.querySelectorAll('select.country').forEach(x => {
      x.value = "DE"
    });

    Object.keys(data).forEach((k) => {
      const field = form.querySelector(`[name="${modelName}[${k}]"]:not([type="hidden"])`) || form.querySelector(`[name="${modelName}[${k}]"]`);
      if (field){
        if (field.type == "checkbox"){
          if (data[k] == "true") field.checked = true
        } else if (window.choices[field.id]){
          field.value = data[k];
          // window.choices[field.id].removeActiveItems();
          window.choices[field.id].setChoiceByValue(field.value)
        } else {
          field.value = data[k];

        }
      }
    });
    document.querySelectorAll('.json-form-renderer').forEach(initJsonFormRenderer);
    modal.show();
  });

  // ---------------------------------------------------------------
  // DELETE ⇢ Soft delete: row.hidden + _destroy = 1
  // ---------------------------------------------------------------
  wrapper.addEventListener("click", (e) => {
    if (!e.target.matches(".remove-row")) return;
    
    const row = e.target.closest("tr");
    row.style.display = "none"; // ausblenden
    row.dataset.destroy = "1";

    // _destroy setzen oder neuer hidden field hinzufügen
    let destroyField = row.querySelector(`input[name*="[_destroy]"]`);
    if (!destroyField) {
      const timestamp = row.dataset.timestamp;
      row.insertAdjacentHTML(
        "beforeend",
        `<input type="hidden" name="${baseModelName}[${modelName}s_attributes][${timestamp}][_destroy]" value="true">`
      );
    } else {
      destroyField.value = "1";
    }

    ensureEmptyPlaceholder();
  });

  // ---------------------------------------------------------------
  // SUBMIT
  // ---------------------------------------------------------------
  formContainer.addEventListener("submit", (e) => {
    if (e.target.id !== `${modelName}-modal-form`) return;
    inputJsonGroupWrapper();
    window.updateJsonForms();
    const form = e.target;
    const data = {};
    if (form.dataset.formurl){
      form.action = form.dataset.formurl
      return false
    }
    e.preventDefault();

    form.querySelectorAll(`[name^="${modelName}["]`).forEach((el) => {
      const key = el.name.match(/\[(.*?)\]/)[1];
      if (el.type == "checkbox"){
        if (el.checked){
          data[key] = "true";
        } else {
          data[key] = "false";
        }
      } else {
        data[key] = el.value;
      }
    });
    const timestamp = currentEditRow
      ? currentEditRow.dataset.timestamp
      : new Date().getTime();

    if (currentEditRow) {
      // id behalten!
      const existing = extractRowObject(currentEditRow);
      if (existing.id) data.id = existing.id;

      currentEditRow.querySelectorAll("input[type='hidden']").forEach((i) => i.remove());
      currentEditRow.insertAdjacentHTML("beforeend", buildHiddenInputs(data, timestamp));
      updateVisibleCells(currentEditRow, data);
    } else {
      const newRow = document.createElement("tr");
      newRow.dataset.timestamp = timestamp;

      newRow.innerHTML = `
        ${buildVisibleCells(data)}
        <td>
          <button type="button" class="btn btn-sm btn-outline-secondary edit-row">Bearbeiten</button>
          <button type="button" class="btn btn-sm btn-danger remove-row">Löschen</button>
        </td>
        ${buildHiddenInputs(data, timestamp)}
      `;

      tableBody.appendChild(newRow);
    }

    ensureEmptyPlaceholder();
    modal.hide();
  });
}
